import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/assets/Nibss-Logo.png";
import SuccessIcon from "../../assets/assets/sucess-pay.svg";
import { useHistory } from "react-router-dom";

const TestSuccess = () => {
  const history = useHistory();

  const goToDashboard = () => {
    history.push({
      pathname: "/dashboard",
    });
  };

  return (
    <div className="application">
      <Link to="/">
        {" "}
        <div className="application-logo">
          <img src={Logo} alt="Nibss" />
        </div>
      </Link>
      <div className="testcase-div">
        <div className="testcase-modal">
          <div className="testcase-modal-image">
            <img src={SuccessIcon} alt="success" />
          </div>
          <h3>Test Result Submitted</h3>
        </div>

        <div className="testcase-modal-btn">
            <button type="button" onClick={() => goToDashboard()}>
              GO TO DASHBOARD
            </button>
          </div>
      </div>
    </div>
  );
};

export default TestSuccess;
